import { render, staticRenderFns } from "./outdbManage.vue?vue&type=template&id=564e5062"
import script from "./outdbManage.vue?vue&type=script&lang=js"
export * from "./outdbManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports